import { Layout } from 'app/layout/layout.types';

export type Scheme = 'auto' | 'dark' | 'light';
export type Theme = 'default' | string;

export interface AppConfig {
    layout: Layout;
    scheme: Scheme;
    theme: Theme;
    logo: string;
    logoText: string;
    logoTextLight: string;
}

export const appConfig: AppConfig = {
    layout: 'modern',
    scheme: 'light',
    theme: 'default',
    logo: 'assets/images/logo/logo.png',
    logoText: 'assets/images/logo/logo-text.png',
    logoTextLight: 'assets/images/logo/logo-text-on-light.png'
};
